// Collection list in slideshow 

$(document).ready(function() {
  $('.collection-slideshow').slick({
    autoplay:false,
    arrows:true,
    prevArrow:'<button type="button" class="slick-prev"><</button>',
    nextArrow:'<button type="button" class="slick-next">></button>',
    centerMode:false,
    slidesToShow:7,
    slidesToScroll:1,
    responsive: [
      {
          breakpoint: 990,
          settings: {
            slidesToShow: 4,
            autoplay:true,
            arrows:false,
          }
      },
      {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            autoplay:true,
            arrows:false,
          }
      }
  ]
  });
});
$(document).ready(function() {
  $('.show-slider').slick({
    arrows:false,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    prevArrow:'<button type="button" class="slick-prev"><</button>',
    nextArrow:'<button type="button" class="slick-next">></button>',
    slidesToShow:1,
    slidesToScroll:1
  });
});